import { CMSResource } from "app/resources/cmsresource";

export class FooterCellTypeResource extends CMSResource {

    rid: number;

    keyName: String;

    active: boolean;

    nameRo: String;

    nameFr: String;

    nameEn: String;

    nameDe: String;

}